import './QuickBookForm.css'
import { Switch } from '@components/ui/switch'
import { AdasBox, AdasButton, AdasTextField, AdasTypography } from '@components/wrapper-components'
import { InfoPopover } from '@components/popover'

export const QuickBookForm = ({
  isConnected,
  optInLineItems,
  isAdminUser,
  qboClassName,
  qboClassNameErrorMessage,
  qboDetails,
  connectToQuickBooks,
  disconnectFromQuickBooks,
  handleLineItemsOptIn,
  handleQboClassNameChange,
  updateQboClassName
}) => {
  return (
    <AdasBox className='space-y-4'>
      {/* QuickBooks connection card */}
      <AdasBox className='rounded-xl border border-border bg-white p-5 flex items-center gap-4'>
        <AdasBox className='w-14 h-14 rounded-xl bg-blue-50 flex items-center justify-center shrink-0'>
          <AdasTypography className='text-[18px] font-bold text-secondary tracking-wide'>QB</AdasTypography>
        </AdasBox>
        <AdasBox className='flex-1 min-w-0'>
          <AdasTypography className='text-[16px] font-bold text-foreground mb-0.5'>QuickBooks Online</AdasTypography>
          <AdasBox className='flex items-center gap-2 flex-wrap'>
            <span
              className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[12px] font-medium ${
                isConnected ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-600'
              }`}
            >
              {isConnected ? 'Connected' : 'Disconnected'}
            </span>
            {isConnected && qboDetails?.companyName && (
              <AdasTypography className='text-[13px] text-muted-foreground'>{qboDetails.companyName}</AdasTypography>
            )}
            {isConnected && qboDetails?.subscriptionName && (
              <AdasTypography className='text-[13px] text-muted-foreground'>· {qboDetails.subscriptionName}</AdasTypography>
            )}
          </AdasBox>
        </AdasBox>
        <AdasButton
          variant='outlined'
          onClick={isConnected ? disconnectFromQuickBooks : connectToQuickBooks}
          className='rounded-lg px-5 text-secondary border-secondary/30 hover:bg-secondary/5 shrink-0'
        >
          {isConnected ? 'Disconnect' : 'Connect'}
        </AdasButton>
      </AdasBox>

      {/* QBO options card — line-items toggle is admin only; class name is visible to all */}
      <AdasBox className='rounded-xl border border-border bg-white p-5 space-y-5'>
        {isAdminUser && (
          <>
            <AdasBox className='flex items-start justify-between gap-4'>
              <AdasBox className='min-w-0'>
                <AdasTypography className='text-[15px] font-semibold text-foreground'>Include Line Items on QBO Invoice</AdasTypography>
                <AdasTypography className='text-[13px] text-muted-foreground mt-0.5'>
                  Show individual line items when creating invoices in QuickBooks
                </AdasTypography>
              </AdasBox>
              <Switch
                checked={!!optInLineItems}
                onCheckedChange={(next) => handleLineItemsOptIn({ target: { value: next ? 'Yes' : 'No' } })}
                aria-label='Toggle line items on QBO invoice'
              />
            </AdasBox>
            <hr className='border-border' />
          </>
        )}
        <AdasBox>
          <AdasBox className='flex items-center gap-1 mb-2'>
            <AdasTypography className='text-[15px] font-semibold text-foreground'>QBO Class Name</AdasTypography>
            <InfoPopover
              ariaLabel='QBO Class Name description'
              enableClick={true}
              className='p-0'
              text={
                <AdasBox className='p-2'>
                  <AdasTypography className='text-sm'>
                    For QBO Plus users only. Class name will be appended after store number for easier identification.
                  </AdasTypography>
                  <AdasTypography className='text-sm mt-4'>Example: 01234-StoreName</AdasTypography>
                </AdasBox>
              }
              popoverWidth='275px'
            />
          </AdasBox>
          <AdasTextField
            id='qboClassName'
            name='qboClassName'
            type='text'
            placeholder='Enter class name...'
            value={qboClassName}
            onChange={handleQboClassNameChange}
            onBlur={updateQboClassName}
            fullWidth
            error={!!qboClassNameErrorMessage}
            helperText={qboClassNameErrorMessage}
          />
        </AdasBox>
      </AdasBox>
    </AdasBox>
  )
}
